<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('close')" />
    <div class="modal">
      <div class="title-close">
        <h1 class="modal-title">
          Are you sure you want to delete “{{ eventPassword.password }}” password?
        </h1>
        <span class="material-icons" @click="$emit('close')">close</span>
      </div>
      <div class="description">Users will not be able to use this password anymore.</div>
      <div class="buttons">
        <main-button outline color="primary" @click="$emit('close')">Cancel</main-button>
        <main-button color="error" @click="$emit('submit', eventPassword.id)">Delete</main-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'event-password-delete-confirm-modal',
  props: {
    eventPassword: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>


<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  text-align: left;
  background-color: white;
  width: 100%;
  position: relative;
  max-width: 43.75rem;
  padding: 2rem;
  border-radius: 20px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.modal::-webkit-scrollbar {
  display: none;
}
.modal-title {
  color: #0277bd;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}
.title-close {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.material-icons {
  cursor: pointer;
}
.description {
  color: #979797;
  font-family: Source Sans Pro;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.buttons {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
</style>
